module.exports = __webpack_public_path__ + "img/nav-design-growing@2x.1d42102.webp";